import { useNavigate } from "react-router-dom";
import { ChevronLeft, LayoutGrid } from "lucide-react";
import { ModuleRow } from "@/mobile/ui";
import { moduleHref } from "@/mobile/open";

const modulesCount = (n) => `${n} ${n === 1 ? "module" : "modules"}`;

// Modules tab: one row per section (Overview, HR, each department, Daily
// Reports). Tapping one ("/?m=modules&sec=<key>") lists only its modules.
export function MobileModuleList({ groups, section }) {
  const nav = useNavigate();
  const open = section ? groups.find((g) => g.key === section) : null;
  if (open) {
    return (
      <div className="pb-6" data-testid={`mobile-modules-${open.key}`}>
        <div className="flex items-center gap-1 px-1.5 pt-2 pb-1.5">
          <button type="button" onClick={() => nav("/?m=modules")} aria-label="Back to all sections" data-testid="mobile-modules-back"
            className="shrink-0 w-9 h-9 flex items-center justify-center rounded-full active:bg-black/5">
            <ChevronLeft className="w-5 h-5" />
          </button>
          <h2 className="text-[17px] font-bold" style={{ fontFamily: "Manrope" }}>{open.label}</h2>
        </div>
        <div className="divide-y divide-[var(--m-border)] border-y border-[var(--m-border)]">
          {open.modules.map((m) => (
            <ModuleRow key={m.to} module={m} onClick={() => nav(moduleHref(m))} sub={m.children?.length ? `${m.children.length} pages` : null} />
          ))}
        </div>
      </div>
    );
  }
  return (
    <div className="pb-6" data-testid="mobile-modules">
      <h2 className="px-3 pt-4 pb-1.5 text-[12px] font-bold uppercase tracking-wide text-[var(--m-muted)]">Sections</h2>
      <div className="divide-y divide-[var(--m-border)] border-y border-[var(--m-border)]">
        {groups.map((g) => (
          <ModuleRow key={g.key} module={{ to: g.key, tid: `section-${g.key}`, label: g.label, icon: g.icon || LayoutGrid }}
            onClick={() => nav(`/?m=modules&sec=${g.key}`)} sub={modulesCount(g.modules.length)} />
        ))}
      </div>
    </div>
  );
}

export function MobileSubmenu({ module: m, section }) {
  const nav = useNavigate();
  if (!m) {
    return <div className="p-6 text-center text-[14px] text-[var(--m-muted)]">This menu isn't available for your account.</div>;
  }
  return (
    <div className="pb-6" data-testid="mobile-submenu">
      <div className="px-3 pt-3 pb-2 text-[13px]">
        <button type="button" onClick={() => nav("/")} className="text-[var(--m-link)]">Home</button>
        {section && (<><span className="mx-1 text-[var(--m-muted)]">›</span>
          <button type="button" onClick={() => nav(`/?sec=${section.key}`)} className="text-[var(--m-link)]">{section.label}</button></>)}
        <h1 className="text-[20px] font-bold mt-1" style={{ fontFamily: "Manrope" }}>{m.label}</h1>
      </div>
      <div className="divide-y divide-[var(--m-border)] border-y border-[var(--m-border)]">
        {m.children.map((c) => (
          <ModuleRow key={c.to} module={{ ...c, icon: c.icon || m.icon }} onClick={() => nav(c.to)} />
        ))}
      </div>
    </div>
  );
}
